// @ts-nocheck
import React from 'react';

function LeftNavWrapper(props) {
  return <ul className={`${props.className || ''}`}>{props.children}</ul>;
}

export default LeftNavWrapper;
